export const searchInputContainerTestId = 'searchInputContainer';
export const searchInputTestId = 'searchInput';
